module.exports = __webpack_public_path__ + "img/tibura1.038f2231.png";